const orderDetail = () => import('@/views/main/order/detail/order-detail.vue')
export default {
  path: '/main/order/detail',
  name: 'orderDetail',
  component: orderDetail,
  children: []
}
